const NewInvoice = "NewInvoice";
const NewOccInvoice = "NewOccInvoice";
const Marketing = "Marketing";
const Test = "Test";
const Community = "Community";
const LoyaltyProgram = "LoyaltyProgram";
const FamilyGroup = "FamilyGroup";

export { NewInvoice, NewOccInvoice, Marketing, Test, Community, LoyaltyProgram, FamilyGroup };
